import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { CommonTexts as Texts } from '../../helpers/LayoutTexts';
import { getGovernmentJobLogoURL } from '../../helpers/Common';

interface Props {
    style: any;
    organizationName: string;
    hasLogo: boolean;
    logoImageUrl: string;
    organizationSeoName: string;
    jobId?: number;
    isGovernmentJob?: boolean;
};

export const Logo: React.FC<Props> = (props) => {
    const navigate = useNavigate();
    const [hover,setHover] = useState(false);
    const logoUrl = props.isGovernmentJob && props.jobId
        ? getGovernmentJobLogoURL(props.jobId)
        : (props.hasLogo && props.logoImageUrl) ? props.logoImageUrl : Texts.defaultCompanyLogo;

    const handleLogoClick = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        navigate("/organization/jobs-at-" + props.organizationSeoName);
    }

    return (        
        <img src={logoUrl}  
            style={{...props.style, ...(hover ? props.style.hover : props.style.normal)}} 
            onMouseEnter={()=>setHover(true)} 
            onMouseLeave={()=>setHover(false)}
            onError={(event) => { event.currentTarget.onerror = null; event.currentTarget.src = Texts.defaultCompanyLogo; }}
            onClick={handleLogoClick} className={"responseive-square"}
            alt="company logo">
        </img>
    );
}